/*
 *    Copyright (c) 2018-2025, insuranceagent All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright
 * notice, this list of conditions and the following disclaimer in the
 * documentation and/or other materials provided with the distribution.
 * Neither the name of the pig4cloud.com developer nor the names of its
 * contributors may be used to endorse or promote products derived from
 * this software without specific prior written permission.
 * Author: insuranceagent
 */

import request from '@/router/axios'
import qs from 'qs'
import {centerObjectPost} from 'meibao-insure/src/api/productCenterNew'

/*
 *  保单相关接口
 */

//  获取包括子渠道的全部保单列表
export function fetchPolicyList(query) {
	return request({
		url: '/dist/distOrder/list',
		method: 'get',
		params: query,
	})
}

//  获取当前账户产生的保单列表
export function fetchMyPolicyList(query) {
	return request({
		url: '/dist/distOrder/myList',
		method: 'get',
		params: query,
	})
}

//  获取包括子渠道的全部保单列表
export function fetchPolicyCheckList(query) {
	return request({
		url: '/dist/distOrder/endorses',
		method: 'post',
		data: query,
	})
}

//  获取当前账户产生的保单列表
export function fetchMyPolicyCheckList(query) {
	return request({
		url: '/dist/distOrder/myEndorses',
		method: 'post',
		data: query,
	})
}

//  获取保单详情
export function getPolicyDetails(id) {
	return request({
		url: '/dist/distOrder/detail/' + id,
		method: 'get',
	})
}

//  获取指定保单的投保人员列表
export function fetchEmployeeList(query) {
	return request({
		url: '/dist/distOrder/empList',
		method: 'get',
		params: query,
	})
}

//  获取指定保单的投保人员列表
export function fetchEmployeeListPage(query) {
	return request({
		url: '/dist/distOrder/empPage',
		method: 'get',
		params: query,
	})
}

//  获取指定保单的批增、批改记录
export function fetchRecordList(query) {
	return request({
		url: '/dist/distOrder/recordList',
		method: 'get',
		params: query,
	})
}

//  获取指定批增或批改记录详情
export function getRecordDetails(id) {
	return request({
		url: '/dist/distOrder/detail/' + id,
		method: 'get',
	})
}

//  获取批增或批改人员信息
export function getEndorsementDetails(id) {
	return request({
		url: '/dist/distOrder/recordEmpList/' + id,
		method: 'get',
	})
}

//  处理中保单
export function proxyProcess(obj) {
	return request({
		url: '/dist/distOrder/proxyProcess',
		method: 'post',
		data: obj,
	})
}

export function proxyProcessMy(obj) {
	return request({
		url: '/dist/distOrder/proxyProcessMy',
		method: 'post',
		data: obj,
	})
}

export function exportDownload(type, orderId) {
	return request({
		url: '/dist/distOrder/exportDownload/' + type + '/' + orderId,
		method: 'get',
		responseType: 'blob',
	})
}

/*
 *  产品相关接口
 */

//  获取指定产品的职业分类
export function getProfessionCategory(id) {
	return request({
		url: '/dist/distProduct/category/current/' + id,
		method: 'get',
	})
}

//  获取指定产品的三级职业分类树
export function getProfessionTree(id) {
	return request({
		url: '/dist/distProduct/category/tree/' + id,
		method: 'get',
	})
}

export function getProfessionTreeWithQuery(id, query = {}) {
	return request({
		url: '/dist/distProduct/category/tree/' + id,
		method: 'get',
		params: query,
	})
}

/*
 *  投保相关接口
 */

//  查找上次未完成保单的暂存填写数据
export function stagingFind(query) {
	return request({
		url: '/dist/distInsure/findStaging',
		method: 'get',
		params: query,
	})
}

//  更新当前填写保单暂存数据
export function stagingRefresh(id, obj) {
	return request({
		url: '/dist/distInsure/refreshStaging/' + id,
		method: 'post',
		headers: {'content-type': 'application/x-www-form-urlencoded'},
		data: qs.stringify(obj),
	})
}

//获取阿里云上传路径
export function getOssParams(obj) {
	return request({
		url: '/admin/common/oss/uploadDir',
		method: 'post',
		data: obj,
	})
}

//  查询历史投保网点
export function getUnitHistory(query) {
	return request({
		url: '/dist/distInsure/unitHistory',
		method: 'get',
		params: query,
	})
}

//  上传文件
export function uploadFile(obj) {
	return request({
		url: '/dist/distInsure/uploadFile',
		method: 'post',
		data: obj,
	})
}

//  校验投被保企业
export function checkUnit(query) {
	return request({
		url: '/dist/distInsure/checkUnit',
		method: 'get',
		params: query,
	})
}

//  校验保单生效日期
export function checkEffectiveDate(query) {
	return request({
		url: '/dist/distInsure/checkEffectiveDate',
		method: 'get',
		params: query,
	})
}

//  计算保费
export function calcPremium(obj) {
	return request({
		url: '/dist/distInsure/calcPremium',
		method: 'post',
		data: obj,
	})
}

//  校验投保信息
export function checkInsure(obj) {
	return request({
		url: '/dist/distInsure/checkInsure',
		method: 'post',
		headers: {'content-type': 'application/x-www-form-urlencoded'},
		data: qs.stringify(obj),
	})
}

//  提交保单
export function insure(obj) {
	return request({
		url: '/dist/distInsure/insure',
		method: 'post',
		headers: {'content-type': 'application/x-www-form-urlencoded'},
		data: qs.stringify(obj),
	})
}

//  查询保单是否可以批增或批改
export function checkEndorse(query) {
	return request({
		url: '/dist/distInsure/checkEndorse',
		method: 'get',
		params: query,
	})
}

//  取消批单
export function cancelEndorse(id) {
	return request({
		url: '/dist/distInsure/cancelEndorse/' + id,
		method: 'put',
	})
}

//  批增
export function endorseAdd(obj) {
	return request({
		url: '/dist/distInsure/addEmployee',
		method: 'post',
		headers: {'content-type': 'application/x-www-form-urlencoded'},
		data: qs.stringify(obj),
	})
}

//  获取开票信息（批增）
export function getInvoiceInfo(query) {
	return request({
		url: '/dist/distInsure/invoiceInfo',
		method: 'get',
		params: query,
	})
}

//  支付保费
export function pay(id) {
	return request({
		url: `/dist/distInsure/pay/${id}`,
		method: 'get',
	})
}

//  查询支付结果
export function getPayStatus(id) {
	return request({
		url: '/dist/distInsure/payStatus/' + id,
		method: 'get',
	})
}

//  批改
export function endorseReplace(obj) {
	return centerObjectPost('/service/batch/add', obj)
}

//  批改起始生效日期
export function getReplaceEffectiveDate(query) {
	return request({
		url: '/dist/distInsure/getEffectiveDate',
		method: 'get',
		params: query,
	})
}

//  查询批单状态
export function getReplaceResult(id) {
	return request({
		url: '/dist/distInsure/queryBatch/' + id,
		method: 'get',
	})
}

//  查询批增状态
export function getEndorseStatus(id) {
	return request({
		url: '/dist/distInsure/queryEndorse/' + id,
		method: 'get',
	})
}

//  查询重新提交表单所属数据
export function getResubmitPolicy(id) {
	return request({
		url: '/dist/distInsure/getResubmitData/' + id,
		method: 'get',
	})
}

//  续保数据
export function getRenewPolicy(id) {
	return request({
		url: '/dist/distInsure/getRenewData/' + id,
		method: 'get',
	})
}

//  非同一网点重复投保人员
export function getRepeatEmpList(obj) {
	return request({
		url: '/dist/distInsure/repeatEmpList',
		method: 'post',
		headers: {'content-type': 'application/x-www-form-urlencoded'},
		data: qs.stringify(obj),
	})
}

//  上传支付凭证
export function payOffline(query, obj) {
	return request({
		url: '/dist/distInsure/uploadPayCertFile',
		method: 'post',
		headers: {'content-type': 'multipart/form-data'},
		params: query,
		data: obj,
	})
}

export function canPayOffline(query) {
	return request({
		url: '/dist/distInsure/checkAllowOffPay',
		method: 'get',
		params: query,
	})
}

export function getDocs(query) {
	return request({
		url: '/dist/distInsure/getDocs',
		method: 'get',
		params: query,
	})
}

/*
 *  保单暂存功能接口
 */
export function getStagingList(query) {
	return request({
		url: '/dist/distOrder/staging/list',
		method: 'get',
		params: query,
	})
}

export function addStaging(obj) {
	return request({
		url: '/dist/distOrder/staging/add',
		method: 'post',
		data: obj,
	})
}

export function delStaging(id) {
	return request({
		url: '/dist/distOrder/staging/del/' + id,
		method: 'delete',
	})
}

export function getStagingDetail(id) {
	return request({
		url: '/dist/distOrder/staging/detail/' + id,
		method: 'get',
	})
}

/*
 *  辅助功能接口
 */

//  获取区域列表
export function getAreaList(level) {
	return request({
		url: '/dist/area/list/' + level,
		method: 'get',
	})
}

//模板下载接口
export function getPolicyEmpTemp(orderId) {
	return request({
		url: `/dist/distInsure/categoryDownload/${orderId}`,
		method: 'get',
		responseType: 'blob',
	})
}

//批量更改被保险人，和批量替换按钮显示
export function getInsuredCheckSpecDate() {
	return request({
		url: '/dist/distInsure/checkSpecDate',
		method: 'get',
	})
}

//批量更改被保险人，和批量替换按钮显示
export function getChannelMainInfo() {
	return request({
		url: '/dist/distChannel/main',
		method: 'get',
	})
}

//校验是否可以重新提交
export function redoOrder(orderId) {
	return request({
		url: `/dist/distInsure/redoOrder/${orderId}`,
		method: 'get',
	})
}

//校验是否可以续保
export function renewOrder(orderId) {
	return request({
		url: `/dist/distInsure/renewOrder/${orderId}`,
		method: 'get',
	})
}

//产品中心续保和重新提交合并 v2/product/recommend
export function getRenewAndRedoOrder(orderData) {
	return centerObjectPost(`/v2/product/recommend`, orderData)
}

//通过营业执照获取企业信息  /agent/employer/insure/calc_premium
export function getUnitInfoByLicense(url) {
	return request({
		// url: `/agent/employer/service/parse_license`,
		url: `/dist/distInsure/parseLicense`,
		method: 'post',
		data: {
			url,
		},
	})
}

// 校验身份证信息
export function checkIdNo(data) {
	return request({
		url: '/dist/distInsure/checkIdno',
		method: 'post',
		data,
	})
}

//校验身份证图片
export function uploadIdNoImg(data) {
	return request({
		url: '/dist/distInsure/uploadIdOcr',
		method: 'post',
		headers: {'content-type': 'multipart/form-data'},
		data,
	})
}

//红包接口/repurchaseOrder/preCheck
export function getPreCheck(queryData) {
	return request({
		url: '/dist/repurchaseOrder/preCheck',
		params: queryData,
	})
}

export function getPreCheckPost(queryData) {
	return request({
		method: 'post',
		url: '/dist/repurchaseOrder/preCheck',
		data: queryData,
	})
}

//红包接口/repurchaseOrder/list
export function getPayResultCheck(queryData) {
	return request({
		url: '/dist/repurchaseOrder/list',
		params: queryData,
	})
}

//生成红包码
export function getGenRedpackCode(orderId) {
	return request({
		url: `/dist/repurchaseOrder/genRedpackCode?orderId=${orderId}`,
		method: 'put',
	})
}

//生成小程序码 /wx/getWxaCodeUnlimit/{appid}
export function getWxCodeMa(scene, appId, type = 0) {
	//要打开的小程序版本。正式版为 release，体验版为 trial，开发版为 develop
	let requestData = {
		appid: appId,
		scene,
		width: 250,
	}
	if (process.env.NODE_ENV !== 'production') {
		Object.assign(requestData, {envVersion: 'trial', checkPath: false})
	}
	//人保分享二维码
	if (type === 1) {
		Object.assign(requestData, {
			page: 'package-center-new/pages/details',
		})
	}
	return request({
		url: `/admin/wx/getWxaCodeUnlimit/${appId}?deduct=1`,
		method: 'post',
		data: requestData,
	})
}

//红包列表
export function getRedpackList(queryData) {
	return request({
		url: '/dist/repurchaseRedpack/page',
		params: queryData,
	})
}

//同步红包状态 /repurchaseOrder/sync
export function getSyncRedpackStatus(orderId) {
	return request({
		url: `/dist/repurchaseOrder/sync?orderId=${orderId}`,
		method: 'put',
		data: {orderId},
	})
}

// 先同步状态！然后生成二维码小程序！
export function getRedpackDetailSync(orderId, tempRedpackStatus = '') {
	return new Promise(async (resolve, reject) => {
		try {
			//先判断是否有状态
			if (tempRedpackStatus === '') {
				let tempCheckResult = await getPayResultCheck({orderIds: [orderId]})
				let {data: dataCheck = []} = tempCheckResult.data || {}
				if (dataCheck.length <= 0) {
					//不满足条件
					reject()
					return
				}
				let {redpackStatus = ''} = dataCheck[0] || {}
				tempRedpackStatus = redpackStatus
			}
			console.log('tempRedpackStatus-------', tempRedpackStatus)
			if (tempRedpackStatus === 'WAIT_CONFIRM') {
				//需要确认
				await getSyncRedpackStatus(orderId)
			}
			//如果没有红包，或者已经领取，则不处理了
			if (tempRedpackStatus === 'NOT_SATISFY' || tempRedpackStatus === 'RECEIVED') {
				reject()
				return
			}
			//获取code
			let result = await getGenRedpackCode(orderId)
			let {code: code1 = -1, data: data1 = ''} = result.data || {}
			if (code1 === 0 && data1 !== '') {
				let tempCode = (await getWxCodeMa(data1, 'wxd143c4746ef02981')) || {}
				let {code: code2 = -1, data: data2 = ''} = tempCode.data || {}
				if (code2 === 0) {
					resolve(data2)
				}
			}
			reject()
		} catch (e) {
		} finally {
		}
	})
}

//下载
//同步红包状态 /repurchaseOrder/sync
export function downloadPolicyFeeDetail(id) {
	return request({
		url: `/dist/distOrder/downloadPolicyFeeDetail`,
		method: 'post',
		data: {id},
	})
}

//获取盖章文件列表
export function getStampFileList(query = {}) {
	return centerObjectPost('/v2/product/open/list', query)
}

//获取盖章文件列表
export function onCancelPolicy(orderId) {
	return centerObjectPost(`/order/cancel/${orderId}`)
}

//  查询事件状态记录
export function queryUserEventLog(query) {
	return request({
		url: '/admin/userLog/list',
		method: 'post',
		data: query,
	})
}

//  添加事件状态记录
export function addUserEventLog(query) {
	return request({
		method: 'post',
		url: '/admin/userLog',
		data: query,
	})
}

// /info/{sn}
export function getPolicyDetailsByPayOrderId(payOrderId) {
	return centerObjectPost(`/order/info/${payOrderId}`)
}
